import { Ticket } from '@hpx-it/queue-client';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useLoadingButton } from 'hooks';
import { Dispatch, SetStateAction } from 'react';

import {
  getDialogBoxStyle,
  getDialogConfirmStyle,
  getDialogExitStyle,
} from './style';

type RescheduleDialogProps = {
  ticket: Ticket;
  setTicket: (ticket: Ticket) => void;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

export const RescheduleDialog = ({
  ticket,
  setTicket,
  open,
  setOpen,
}: RescheduleDialogProps) => {
  const loadingButtonProps = useLoadingButton(async () => {
    setTicket(await ticket.on('DEFERED_BY_RESIDENT'));
    setOpen(false);
  });

  const handleRescheduleDialogClose = async () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleRescheduleDialogClose}>
      <Box {...getDialogBoxStyle()}>
        <DialogTitle>Reschedule</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will cancel your existing timeslot and allow you to reschedule.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleRescheduleDialogClose}
            {...getDialogExitStyle()}
          >
            Exit
          </Button>
          <Button {...getDialogConfirmStyle()} {...loadingButtonProps}>
            Confirm
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
